// extracted by mini-css-extract-plugin
export default {"end_sale_banner":"EndSaleView-module--end_sale_banner--iY1GH"};